import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { inComeinChannel } from '@/utils/const';

/**
 * 行情数据服务组合式函数
 */
export function useQuoteService() {
	const { quote, quote_sse } = useModuleData();

	const formatSseDateTime = (date, time) => {
		const dateStr = String(date);
		const timeStr = String(time);

		const year = dateStr.substring(0, 4);
		const month = dateStr.substring(4, 6);
		const day = dateStr.substring(6);

		const timeLen = timeStr.length;
		const hours = timeStr.substring(0, timeLen === 5 ? 1 : 2);
		const mins = timeStr.substring(timeLen === 5 ? 1 : 2, timeLen === 5 ? 3 : 4);
		const seconds = timeStr.substring(timeLen === 5 ? 3 : 4);

		return {
			tradingDay: `${month}/${day} ${hours}:${mins}:${seconds}`,
			fullTime: `${year}/${month}/${day} ${hours}:${mins}:${seconds}`
		};
	};
	const transformSseData = sseData => {
		if (!sseData) return null;

		const { quoteLine = {}, quoteSnap = {} } = sseData;
		const { date, time } = quoteLine;
		const { last, prev_close, change, chg_rate, high, low, amount, volume } = quoteSnap?.snap || {};

		if (!date || !time) return null;

		const { tradingDay, fullTime } = formatSseDateTime(date, time);

		return {
			closePrice: last || prev_close,
			change,
			changePct: chg_rate,
			tradingDay,
			highPrice: high,
			lowPrice: low,
			turnoverValue: amount,
			turnoverVolume: volume,
			time: fullTime
		};
	};

	const loadQuoteData = async (params = {}) => {
		const [err, res] = await quote.fetch(params);
		if (err) return null;
		return res?.data || null;
	};
	const loadRealtimeQuoteData = async (params = {}) => {
		// 合规：进门渠道不允许展示实时数据
		const fetchParams = inComeinChannel() ? { ...params } : { ...params, realType: 1 };

		const [err, res] = await quote.fetch(fetchParams);
		if (err) return null;
		return res?.data || null;
	};

	const loadSseQuoteData = async (params = {}) => {
		// 合规：进门渠道降级使用标准数据服务
		if (inComeinChannel()) {
			return loadQuoteData(params);
		}

		const [err, res] = await quote_sse.fetch(params);
		if (err) return null;
		const rawData = res?.data || null;
		return transformSseData(rawData);
	};

	return {
		loadQuoteData,
		loadRealtimeQuoteData,
		loadSseQuoteData
	};
}
